import { createPlugin as b, parseRecord as h, FolderController as m, ValueMap as x, FolderApi as g } from "@tweakpane/core";
const f = "import-export", S = b({
  id: f,
  type: "blade",
  accept(n) {
    const t = h(n, (e) => ({
      title: e.optional.string,
      view: e.required.constant(f),
      expanded: e.optional.boolean
    }));
    return t ? { params: t } : null;
  },
  controller(n) {
    const t = new m(n.document, {
      blade: n.blade,
      expanded: n.params.expanded,
      root: !0,
      props: x.fromObject({
        title: n.params.title || "Import / Export"
      }),
      viewProps: n.viewProps
    });
    return t.importState = () => !0, t.exportState = () => ({}), t;
  },
  api(n) {
    if (!(n.controller instanceof m))
      return null;
    const t = { value: "" }, e = new g(n.controller, n.pool), l = e.addBinding(t, "value"), i = e.addButton({ title: "Import" }), a = e.addButton({ title: "Export" }), c = e.element.querySelector("button"), y = l.element.querySelector(".tp-lblv_v"), p = l.element.querySelector("input"), v = i.element.querySelector("button"), d = a.element.querySelector("button"), u = i.element.querySelector(".tp-btnv");
    return e.element.style.overflow = "hidden", c.style.textAlign = "left", c.style.paddingLeft = "8px", y.style.width = "100%", p.placeholder = "Copy / Paste config here", u.style.display = "flex", v.style.marginRight = "2px", d.style.marginLeft = "2px", l.element.querySelector(".tp-lblv_l").remove(), u.appendChild(d), a.element.remove(), i.on("click", () => {
      if (!t.value.trim()) {
        alert("No tweakpane config to import");
        return;
      }
      let o;
      try {
        o = JSON.parse(t.value);
      } catch {
      }
      if (!o || typeof o != "object" || !Array.isArray(o.children))
        throw alert("Could not parse tweakpane config"), new Error("Could not parse tweakpane config");
      for (let r = 0; r < e.controller.parent.children.length; r++) {
        const s = e.controller.parent.children[r];
        s === e.controller || s.importState(o.children[r]);
      }
    }), a.on("click", () => {
      t.value = JSON.stringify({
        disabled: !1,
        expanded: !0,
        hidden: !1,
        title: void 0,
        children: e.controller.parent.children.map((o) => o.exportState())
      }), l.refresh(), p.focus(), p.select(), navigator.clipboard.writeText(t.value);
    }), e;
  }
});
export {
  f as id,
  S as plugin
};
